/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  Modal,
  Form,
  FormGroup,
  Col,
  Button,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import ControlTips from '@/components/ControlTips';
import FormBlock from '@/components/FormBlock';
import Select from 'loracoms/Select';
import IntlMsg from 'lorautils/intl/IntlMsg';
import callAPI from '@/api/callAPI';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  deviceId: PropTypes.string.isRequired,
  gateway: PropTypes.string.isRequired,
};

const formatter = gw => (
  <span>
    {gw.name}
    <span className={styles.infos}>
      <span className={styles.info}>
        <i className="fa fa-angle-left" />
        ID: {gw.id}
        <i className="fa fa-angle-right" />
      </span>
    </span>
  </span>
);

class AddModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
      gateway: props.gateway,
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.topoview');
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  componentWillMount() {
    this.loadGateways();
  }

  componentWillReceiveProps(nextProps) {
    const { showModal, gateway } = nextProps;
    if (showModal !== this.props.showModal) {
      this.setState({ showModal });
    }
    this.setState({ gateway });
  }

  loadGateways() {
    callAPI({
      endpoint: '/lora/gateways',
      query: {
        mark: 0,
        limit: 1000,
        sort: '-lastOn',
      },
    }).then((res) => {
      const { list } = res;
      const options = _.map(list, l => ({
        label: l.name,
        value: l.id,
        formatter: () => formatter(l),
      }));
      this.setState({ options });
    }).catch(() => {});
  }

  handleOnChange(gateway) {
    this.setState({ gateway });
  }

  handleOnConfirm() {
    const { gateway = '' } = this.state;
    if (gateway.length === 0) {
      this.setState({ empty: true });
      return;
    }
    callAPI({
      endpoint: `/lora/nodes/${this.props.deviceId}/deflink`,
      method: 'POST',
      body: { gateway },
    }).then(() => {
      this.props.onSuccess(gateway);
    }).catch((err) => {
      this.setState({ error: err.code });
    });
  }

  handleError() {
    _.delay(() => {
      this.setState({ error: null });
    }, 3 * 1000);
  }

  render() {
    const {
      showModal,
      empty = false,
      gateway,
      error = null,
      options = [],
    } = this.state;
    return (
      <Modal
        show={showModal}
        bsClass="aisz-modal-light"
        onHide={() => {
          this.setState({ gateway: '', empty: false, error: null });
          this.props.onHide();
        }}
        backdrop="static"
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <Form horizontal>
            <FormGroup controlId="formHorizontalEmail" className="clearfix">
              <Col md={3}>
                <span className={`aisz-control-label ${styles.inline}`}>
                  {this.intlMsg.msg('deflink.gatewayid')} *
                </span>
              </Col>
              <Col md={7}>
                <Select
                  options={options}
                  value={gateway}
                  onChange={this.handleOnChange}
                />
                <ControlTips
                  show={empty}
                  message={this.intlMsg.msg('deflink.empty')}
                  azStyle="danger"
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col md={7} mdOffset={3}>
                <Button
                  bsStyle="aisz-primary"
                  onClick={() => this.handleOnConfirm()}
                  className={styles.fullWidth}
                >
                  {this.intlMsg.msg('deflink.confirm')}
                </Button>
              </Col>
            </FormGroup>
            <FormGroup>
              <Col md={7} mdOffset={3}>
                <FormBlock
                  azStyle="danger"
                  show={error !== null}
                  onHide={() => this.handleError()}
                  message={this.intlMsg.errorMsg(error)}
                />
              </Col>
            </FormGroup>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

AddModal.propTypes = propTypes;

export default injectIntl(AddModal);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/TopoView/coms/AddModal/index.jsx